import { globalSTT as stt, blobToBase64, audioToWavBlob} from '@/components/Chat/STT';
import { KeepAwake } from '@capacitor-community/keep-awake';
//import Live2D from '@/controllers/Live2D';
import { speechGetResponse } from '@/controllers/llm';

export const handlers = {
    onToggleSTTOnStart: () => {},
    onToggleSTTOnEnd: () => {},
    onToggleSTTOnSuccess: () => {},
    onToggleSTTOff: () => {},
    onSpeechEnd: (audio: string, text: string) => {}
}

stt.onSpeechEnd = async (audio) => {
    const uri = await blobToBase64(audioToWavBlob(audio))
    const r = await speechGetResponse(uri);
    console.log('onSpeechEnd', r)
    if (r.segments[0].no_speech_prob > 0.08) {
        //tts.speak("Excuse me?")
        return;
    }

    handlers.onSpeechEnd(uri, r.text)
}

export async function toggleSTToff() {
    stt.stop();
    handlers.onToggleSTTOff();
    KeepAwake.allowSleep();
    const Live2D = await import('@/controllers/Live2D');
    Live2D.stopSpeaking();
}

export async function toggleSTTon() {
    handlers.onToggleSTTOnStart()
    try {
        await stt.start();
        handlers.onToggleSTTOnSuccess();
        KeepAwake.keepAwake();
    } catch {
        console.log("no mic")
    }
    handlers.onToggleSTTOnEnd();
}

export default { handlers, toggleSTToff, toggleSTTon }